import React from 'react';

import {
  IndexView,
  Faq as FaqView,
  ContactPage as ContactPageView,
  Pricing as PricingView,
  About as AboutView,
  HelpCenter as HelpCenterView,
  CompanyTerms as CompanyTermsView,
  NotFoundCover as NotFoundCoverView,
  Cart as CartView,
  Checkout as CheckoutView,
  EmptyCart as EmptyCartView,
  Listing as ListingView,
  Promotions as PromotionsView,
  OrderComplete as OrderCompleteView,
  ProductOverview as ProductOverviewView,
} from 'views';

const routes = [
  {
    path: '/',
    renderer: (params = {}): JSX.Element => <IndexView {...params} />,
  },
  {
    path: '/faq',
    renderer: (params = {}): JSX.Element => <FaqView {...params} />,
  },
  {
    path: '/contact-page',
    renderer: (params = {}): JSX.Element => <ContactPageView {...params} />,
  },
  {
    path: '/about',
    renderer: (params = {}): JSX.Element => <AboutView {...params} />,
  },
  {
    path: '/pricing',
    renderer: (params = {}): JSX.Element => <PricingView {...params} />,
  },
  {
    path: '/help-center',
    renderer: (params = {}): JSX.Element => <HelpCenterView {...params} />,
  },
  {
    path: '/company-terms',
    renderer: (params = {}): JSX.Element => <CompanyTermsView {...params} />,
  },
  {
    path: '/not-found-cover',
    renderer: (params = {}): JSX.Element => <NotFoundCoverView {...params} />,
  },
  {
    path: '/ecommerce/cart',
    renderer: (params = {}): JSX.Element => <CartView {...params} />,
  },
  {
    path: '/ecommerce/checkout',
    renderer: (params = {}): JSX.Element => <CheckoutView {...params} />,
  },
  {
    path: '/ecommerce/empty-cart',
    renderer: (params = {}): JSX.Element => <EmptyCartView {...params} />,
  },
  {
    path: '/ecommerce/listing',
    renderer: (params = {}): JSX.Element => <ListingView {...params} />,
  },
  {
    path: '/ecommerce/promotions',
    renderer: (params = {}): JSX.Element => <PromotionsView {...params} />,
  },
  {
    path: '/ecommerce/order-complete',
    renderer: (params = {}): JSX.Element => <OrderCompleteView {...params} />,
  },
  {
    path: '/ecommerce/product-overview',
    renderer: (params = {}): JSX.Element => <ProductOverviewView {...params} />,
  },
];

export default routes;
